module.exports = __webpack_public_path__ + "files/98255d04bb0ce821171ea055fdfcc53f.eot";


//////////////////
// WEBPACK FOOTER
// ./fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-regular.eot
// module id = 454
// module chunks = 76